import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgMessage(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M81.656 50.028v33.773c0 3.775-3.053 6.835-6.818 6.835H29.924a1.5 1.5 0 0 0-.962.35l-10.485 8.642c-.985.813-2.477.114-2.477-1.17v-48.43c0-3.774 3.053-6.835 6.818-6.835h52.02c3.765 0 6.818 3.06 6.818 6.835Z"
        fill="#F1F5F9"
      />
      <path
        d="M81.656 50.322v31.023H36.018c-5.177 0-9.371-4.188-9.371-9.351V43.48c0-.098 0-.188.008-.287h47.863c3.944 0 7.138 3.19 7.138 7.129Z"
        fill="#F1F5F9"
      />
      <path
        d="M81.656 50.322v31.023H36.018c-5.177 0-9.371-4.188-9.371-9.351V43.48c0-.098 0-.188.008-.287h47.863c3.944 0 7.138 3.19 7.138 7.129Z"
        fill="#E2E8F0"
      />
      <path
        d="M95.852 37.68v48.343c0 1.29-1.505 2.003-2.51 1.182l-9.89-8.129a1.567 1.567 0 0 0-.975-.353H36.22a6.91 6.91 0 0 1-6.91-6.908V37.68a6.91 6.91 0 0 1 6.91-6.908h52.723a6.91 6.91 0 0 1 6.91 6.908Z"
        fill="#78B441"
      />
      <path
        d="M84.77 41.132a1.1 1.1 0 1 1 0 2.199H40.268a1.1 1.1 0 1 1 0-2.2H84.77ZM84.77 49.366a1.1 1.1 0 1 1 0 2.2H40.268a1.1 1.1 0 1 1 0-2.2H84.77ZM84.77 57.608a1.1 1.1 0 1 1 0 2.2H40.268a1.1 1.1 0 1 1 0-2.2H84.77ZM84.77 65.842a1.1 1.1 0 1 1 0 2.2H63.14a1.1 1.1 0 1 1 0-2.2h21.63Z"
        fill="#007A5F"
      />
      <path
        d="M106.144 22.328a.8.8 0 0 1 1.053 1.205l-7.481 6.545a.8.8 0 1 1-1.053-1.204l7.481-6.546ZM107.352 34.328a.801.801 0 0 1 .506 1.518l-5.61 1.87a.8.8 0 1 1-.506-1.518l5.61-1.87ZM93.828 19.714a.8.8 0 0 1 1.372.822l-2.806 4.676a.8.8 0 1 1-1.37-.823l2.804-4.675Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgMessage)
